import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import mixpanel from 'mixpanel-browser'

import { useOnboardingStore } from '../../store/onboarding-store'

import Button from '../../common/components/Button'
import Layout from '../../common/components/Layout'
import styles from './Priorities.module.css'
import { authFetch } from '../../common/utils/cognito'
import PrioritiesList from '../../common/components/PrioritiesList'
import { t } from 'i18next'

const PrioritiesPage = () => {
  const { highRisk, recommendations } = useOnboardingStore()
  const [selectedPriorities, setSelectedPriorities] =
    useState<number[]>(recommendations)
  const navigate = useNavigate()

  useEffect(() => {
    setSelectedPriorities(recommendations)
  }, [recommendations])

  const handleCreateFeedClick = async () => {
    try {
      let response

      response = await authFetch(
        `${process.env.REACT_APP_API_URL}/user-onboarding`,
        {
          method: 'PATCH',
          body: JSON.stringify({
            complete: true,
          }),
        },
      )

      if (!response.ok) {
        throw new Error(response.statusText)
      }

      response = await authFetch(`${process.env.REACT_APP_API_URL}/me`, {
        method: 'PATCH',
        body: JSON.stringify({
          trackIds: selectedPriorities,
        }),
      })

      if (!response.ok) {
        throw new Error(response.statusText)
      }

      mixpanel.track('Onboarding Track Selection Completed')

      if (highRisk) {
        navigate('/warning')
      } else {
        navigate('/feed')
      }
    } catch (error) {
      console.error(error)
    }
  }

  const onSkipClick = () => {
    mixpanel.track('Onboarding Track Selection Skipped')
  }

  return (
    <Layout
      hasBackButton
      contentStyles={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div className={styles.titleContainer}>
        <h3 className={styles.title}>{t('priorities.title')}</h3>
        <span className={styles.subtitle}>{t('priorities.header')}</span>
      </div>
      <div className={styles.list}>
        <PrioritiesList
          selectedPriorities={selectedPriorities}
          setSelectedPriorities={setSelectedPriorities}
        />
      </div>
      <div className={styles.actionContainer}>
        <Button
          title={t('priorities.create')}
          onClick={handleCreateFeedClick}
          disabled={selectedPriorities.length === 0}
        />
        <Link to="/feed" onClick={onSkipClick} className={styles.skip}>
          {t('onboarding.skip')}
        </Link>
      </div>
    </Layout>
  )
}

export default PrioritiesPage
